import React, { useState } from 'react';
import { ActivityRendererProps } from './types';

const WriteActivity: React.FC<ActivityRendererProps> = ({ activity, onComplete }) => {
  const [answers, setAnswers] = useState<string[]>([]);
  const [submitted, setSubmitted] = useState(false);

  const handleAnswerChange = (index: number, value: string) => {
    const newAnswers = [...answers];
    newAnswers[index] = value;
    setAnswers(newAnswers);
  };

  const handleSubmit = () => {
    setSubmitted(true);
    onComplete(90);
  };

  return (
    <div className="write-activity">
      <h3>Writing Practice</h3>
      
      <div className="writing-exercises">
        {activity.content.exercises.map((exercise: any, index: number) => (
          <div key={index} className="writing-exercise">
            <div className="exercise-prompt">
              <strong>Exercise {index + 1}:</strong> {exercise.prompt}
            </div>
            <div className="exercise-example">
              <em>Example: {exercise.example}</em>
            </div>
            <textarea
              className="writing-input"
              placeholder="Write your sentence here..."
              value={answers[index] || ''}
              onChange={(e) => handleAnswerChange(index, e.target.value)}
              disabled={submitted}
            />
          </div>
        ))}
      </div>
      
      <div className="write-activity-actions">
        <button 
          className="submit-btn"
          onClick={handleSubmit}
          disabled={submitted || answers.some(answer => !answer?.trim())}
        >
          {submitted ? '✓ Submitted' : 'Submit Answers'}
        </button>
      </div>
    </div>
  );
};

export default WriteActivity;

